export { default as WorkWithUs } from './WorkWithUs';
export { default as TermsAndConditions } from './general-info/TermsAndConditions';
export { default as CookiesPolicy } from './general-info/CookiesPolicy';
export { default as PrivacyPolicy } from './general-info/PrivacyPolicy';
export { default as Checkout } from './Checkout';
export { default as Landlord } from './Landlord';
export { default as CheckoutPayment } from './CheckoutPayment';
export { default as ApartmentDetails } from './ApartmentDetails';
export { default as Faq } from './Faq';
